module.exports = __webpack_public_path__ + "img/snake-min.db885d6e.png";